import Box from "ds/components/Box";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import Badge from "ds/components/Badge";
import EmptyState from "ds/components/EmptyState";
import { EmptystateListColored } from "components/icons/generated";
import Callout from "ds/components/Callout";

import styles from "./styles.module.css";

const VCSIntegrationTroubleshootingIssues = () => {
  return (
    <div className={styles.content}>
      <PageInfoHeaderWrapper>
        <Box align="center" gap="medium">
          <PageInfoHeaderTitle title="Issues" />
          <Badge variant="blue" type="strong" text="Coming soon" className={styles.badge} />
        </Box>
      </PageInfoHeaderWrapper>
      <Callout variant="info" title="This section is under development." />
      <Box justify="center" align="center" fullHeight padding="large">
        <EmptyState
          icon={EmptystateListColored}
          title="More insights coming soon"
          caption="We’re actively working on surfacing additional troubleshooting insights - like integration issues and misconfigurations - to help you resolve problems faster. Stay tuned!"
        />
      </Box>
    </div>
  );
};

export default VCSIntegrationTroubleshootingIssues;
